import * as yup from 'yup';

// No necesitas una Regex manual tan compleja, Yup ya tiene .email() 
// que es muy robusto, pero si prefieres la tuya, está bien.
export const loginSchema = yup.object().shape({
    correo: yup.string()
        .trim() // Elimina espacios al inicio y final
        .email('El formato del correo no es válido') 
        .required('El correo es obligatorio'),
    password: yup.string()
        .min(6, 'La contraseña debe tener al menos 6 caracteres')
        .required('La contraseña es obligatoria'),
});